var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2761_2852)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2761_2852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "#3F9C35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V15.9984H0V0Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V8.00156H0V0Z",
    fill: "#00B9E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1938 15.5999C13.182 15.5999 14.7938 13.9881 14.7938 11.9999C14.7938 10.0117 13.182 8.3999 11.1938 8.3999C9.20553 8.3999 7.59375 10.0117 7.59375 11.9999C7.59375 13.9881 9.20553 15.5999 11.1938 15.5999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9951 15C13.652 15 14.9951 13.6569 14.9951 12C14.9951 10.3431 13.652 9 11.9951 9C10.3383 9 8.99512 10.3431 8.99512 12C8.99512 13.6569 10.3383 15 11.9951 15Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1969 9.99854L15.5766 11.0767L16.6078 10.5845L16.1203 11.6157L17.1984 12.0001L16.1203 12.3845L16.6078 13.4157L15.5766 12.9235L15.1969 14.0017L14.8125 12.9235L13.7812 13.4157L14.2734 12.3845L13.1953 12.0001L14.2734 11.6157L13.7812 10.5845L14.8125 11.0767L15.1969 9.99854Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2761_2852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2761_2852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAze);
export default __webpack_public_path__ + "static/media/Aze.71e9ff002df15d89f6867c0cb27122aa.svg";
export { ForwardRef as ReactComponent };